import {
    isPoland,
    isSerbia,
} from './isCountry';

export default function preparePhoneNumber(value: string): string {
    const cleaned = value.replace(/[^\d]+/g, '');
    // should expand in the future
    if (isPoland() && !cleaned.startsWith('48')) {
        return `48${cleaned}`;
    } else if (isSerbia() && !cleaned.startsWith('381')) {
        return `381${cleaned}`;
    } else {
        return cleaned;
    }
}
